import { Box, FormControlLabel, Stack, Typography } from '@mui/material';
import theme from '@shared/themes/darkTheme';
import { formatDatetime } from '@utils/date';
import { useTradingKillSwitch } from '../../hooks/useTradingKillSwitch';
import { KillSwitchButton } from '../KillSwitchButton';
import { TradingOtcParamsForm } from './TradingOtcParamsForm';
import { useTradingOtcForm } from './useTradingOtcForm';

export const TradingOtc = () => {
  const { killSwitch, onToggleKillSwitch, onToggleLimitKillSwitch } = useTradingKillSwitch('otc');
  const { formData } = useTradingOtcForm();

  return (
    <Stack gap={2} width="100%" p={2}>
      {formData && <Typography fontSize={11}>Params version: {formData.id}</Typography>}
      {killSwitch ? (
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="space-around"
          sx={{
            backgroundColor: theme.palette.background.darker,
            padding: 1,
            borderRadius: '2em',
            border: '0.5em solid transparent',
            borderImage:
              '8 repeating-linear-gradient(45deg, red 0, red 1.1em, black 1.3em, black 1.4em, hsla(50, 100%, 60%, 1.00) 1.41em, hsla(50, 100%, 50%, 1.00) 2.6em, black 2.7em, black 2.9em)',
          }}
        >
          <Stack direction="column" alignItems="flex-start">
            <FormControlLabel
              control={
                <KillSwitchButton sx={{ m: 1 }} checked={killSwitch.active} onChange={(event, checked) => onToggleKillSwitch(event, checked)} />
              }
              label={`Kill Switch: ${killSwitch.active ? 'On' : 'Off'}`}
            />
            <Typography style={{ fontSize: 10, fontWeight: 800 }}>
              Last triggered by {!killSwitch.user.full_name ? killSwitch.user.id : killSwitch.user.full_name} at{' '}
              {formatDatetime(killSwitch.timestamp)}
            </Typography>
          </Stack>

          <Stack direction="column" alignItems="flex-start">
            <FormControlLabel
              control={
                <KillSwitchButton
                  sx={{ m: 1 }}
                  checked={killSwitch.active_limit_orders}
                  onChange={(event, checked) => onToggleLimitKillSwitch(event, checked)}
                />
              }
              label={`Limit Order Kill Switch: ${killSwitch.active_limit_orders ? 'On' : 'Off'}`}
            />
            <Typography style={{ fontSize: 11, fontWeight: 800 }}>
              Last triggered by {!killSwitch.user.full_name ? killSwitch.user.id : killSwitch.user.full_name} at{' '}
              {formatDatetime(killSwitch.timestamp)}
            </Typography>
          </Stack>
        </Box>
      ) : null}
      <TradingOtcParamsForm />
    </Stack>
  );
};
